import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=6062a1dd&scoped=true&lang=pug"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"
import style0 from "./Base.vue?vue&type=style&index=0&id=6062a1dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062a1dd",
  null
  
)

export default component.exports